import { Factory } from 'rosie';

Factory.define('TranslationFromEsToEn')
  .attr('content', 'default translated content')
  .attr('parentLanguage', 'es')
  .attr('contentLanguage', 'en')
  .attr('translatedAt', () => new Date().toISOString());
